// extracted by mini-css-extract-plugin
export default {"container":"container__ALZjNx8E","icon":"icon__dixRzOUo","error":"error__vzJtXhXL","text":"text__kqBMwzSP"};